import { SetUpAutoshipProductInfo } from '@libs/shared-ui';

import { ImageType, useProduct } from '@/entities/product';

export const ProductInfo = () => {
    const { product } = useProduct();

    if (!product || !product.media.length) return null;

    // TODO: Need to add fallback src image
    const firstImage = product.media.find(item => item.type === 'image') as ImageType | undefined;

    return <SetUpAutoshipProductInfo name={product.name} imageUrl={firstImage?.url || ''} />;
};
